import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCliNSlgewfRCiqEjcnDPPX8n-KJk-8eBI",
  authDomain: "rsc-chaines.firebaseapp.com",
  projectId: "rsc-chaines",
  storageBucket: "rsc-chaines.appspot.com",
  messagingSenderId: "736355519638",
  appId: "1:736355519638:web:a3cdb303095525b9e706b7",
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();

export { db, storage, auth, firebase as default };
